import * as Sentry from '@sentry/react'

/**
 * Gemello di `apps/worker/src/osservabilita.ts`. Senza DSN non inizializza
 * nulla: in sviluppo e nei test il portale non segnala a un progetto reale.
 *
 * Il DSN di un client browser e' pubblico per costruzione (finisce nel bundle),
 * quindi non e' un segreto — ma cambia fra ambienti, percio' resta una VITE_.
 */
export function avviaOsservabilita(env: ImportMetaEnv): boolean {
  if (!env.VITE_SENTRY_DSN) return false
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_SENTRY_ENVIRONMENT ?? 'produzione',
    // Il portale mostra anagrafiche, letture e importi di clienti terzi: a
    // Sentry non deve arrivare il contenuto, solo che e' esploso e dove.
    sendDefaultPii: false,
    tracesSampleRate: 0,
  })
  return true
}

export interface Contesto {
  readonly dichiarazioneId?: number
  readonly impiantoId?: string
  readonly tipo?: string
}

/** Stessi tag di correlazione del worker, cosi' i due progetti si leggono insieme. */
export function segnala(errore: unknown, contesto: Contesto): void {
  try {
    Sentry.withScope((scope) => {
      if (contesto.dichiarazioneId !== undefined) scope.setTag('dichiarazione_id', String(contesto.dichiarazioneId))
      if (contesto.impiantoId !== undefined) scope.setTag('impianto_id', contesto.impiantoId)
      if (contesto.tipo !== undefined) scope.setTag('tipo', contesto.tipo)
      Sentry.captureException(errore)
    })
  } catch {
    // Un guasto dell'osservabilita non deve rompere la pagina.
  }
}
